export const normalizeChecklistVisualSettings = (visualSettings = {}) => ({
    ...visualSettings,
    count_of_cfs_full:
        visualSettings?.count_of_cfs_full === undefined
            ? null
            : visualSettings.count_of_cfs_full,
    collapsed_by_default: visualSettings?.collapsed_by_default === true,
})

export const isChecklistCollapsedByDefault = (visualSettings) =>
    normalizeChecklistVisualSettings(visualSettings).collapsed_by_default
